import React from "react";
import ContentType from "../Avatar/ContentType";

const CardResource = ({ type, name, thumbnailURL, onClick }) => {
    return <div className="cardResourceContainer">
        <div className="cardResourceImage"
            style={{ background: "url(" + thumbnailURL + ") lightgray 50% / cover no-repeat",
                cursor: onClick ? "pointer" : "default"
            }}
            onClick={onClick}
        />
        <div className="cardResourceBottom">
            {type ? <ContentType typeId={type.id}/> : null}
            <div style={{ display: "flex", flexGrow: "1", flexDirection: "column", maxWidth: "80%" }}>
                <span style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>{name}</span>
                <span style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", color: "var(--grey-base)" }}>{type.name}</span>
            </div>
        </div>
    </div>;
};

export default CardResource;
